import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    handleProductLotInput,
    handleLotConfirm,
} from '../../../redux/actions/sales_order/sales_order.actions';
import moment from 'moment';
import { MiniSpinner } from '../../layouts/Spinner';

function PickLotNo({
    show,
    onHide,
    item_product_lot,
    item_product_qty,
    product_lot_inputs,
    handleProductLotInput,
    handleLotConfirm,
    loading,
}) {
    const [selectedLots, setSelectedLots] = useState([]);

    // Re-initialize whenever the modal opens
    useEffect(() => {
        if (show) {
            const initialized = item_product_lot.map((lot) => ({
                _id: lot._id,
                lot_no: lot.lot_no,
                supplier_name: lot.supplier_name,
                available_quantity: lot.quantity,
                product_unit_name: lot.product_unit_name,
                selected_quantity: product_lot_inputs[`lot_${lot._id}`] || 0,
                expiry_date: lot.expiry_date,
                checked: !!product_lot_inputs[`lot_${lot._id}`],
            }));
            setSelectedLots(initialized);
        }
    }, [show, item_product_lot, product_lot_inputs]);

    // Sum up all selected quantities from Redux inputs
    const selectedTotal = () =>
        item_product_lot.reduce(
            (sum, lot) =>
                sum + (parseFloat(product_lot_inputs[`lot_${lot._id}`]) || 0),
            0
        );

    // Required quantity for this item
    const requiredQty = parseFloat(item_product_qty) || 0;

    // User clicked Cancel: clear local state & Redux inputs, then hide
    const onCancel = () => {
        setSelectedLots([]);
        item_product_lot.forEach((lot) => {
            handleProductLotInput({
                target: { name: `lot_${lot._id}`, value: '' },
            });
        });
        onHide();
    };

    // User clicked Confirm: only hide on successful match
    const onConfirm = async () => {
        const ok = await handleLotConfirm();
        if (ok) {
            onHide();
        }
        // if not ok, toast error shown inside handleLotConfirm
    };

    // Backdrop click or close-icon: behave like Cancel if mismatch, otherwise just hide
    const handleClose = () => {
        if (selectedTotal() === requiredQty) {
            onHide();
        } else {
            onCancel();
        }
    };

    const handleCheckboxChange = (index) => {
        const updated = [...selectedLots];
        updated[index].checked = !updated[index].checked;

        if (!updated[index].checked) {
            handleProductLotInput({
                target: {
                    name: `lot_${updated[index]._id}`,
                    value: '',
                },
            });
        }

        setSelectedLots(updated);
    };

    const handleQuantityChange = (index, value) => {
        const updated = [...selectedLots];
        updated[index].selected_quantity = value;
        setSelectedLots(updated);

        handleProductLotInput({
            target: {
                name: `lot_${updated[index]._id}`,
                value,
            },
        });
    };

    return (
        <Modal
            centered
            dialogClassName="modal-container"
            show={show}
            onHide={handleClose}
            size="lg"
            animation={true}
        >
            <Modal.Header closeButton dialogClassName="p-0">
                <Modal.Title>Product Lot No.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <MiniSpinner />
                ) : (
                    <>
                        {' '}
                        {selectedLots.length === 0 ? (
                            <p>No product lot records found.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped f-regular">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Lot No</th>
                                            <th>Supplier</th>
                                            <th>Available Qty</th>
                                            <th>Qty</th>
                                            <th>Expiry Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedLots.map((lot, index) => (
                                            <tr key={lot._id}>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={lot.checked}
                                                        onChange={() =>
                                                            handleCheckboxChange(
                                                                index
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td>{lot.lot_no}</td>
                                                <td>{lot.supplier_name}</td>
                                                <td>
                                                    {lot.available_quantity} (
                                                    {lot.product_unit_name})
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        min="0"
                                                        max={
                                                            lot.available_quantity
                                                        }
                                                        name={`lot_${lot._id}`}
                                                        value={
                                                            lot.checked
                                                                ? lot.selected_quantity
                                                                : ''
                                                        }
                                                        onChange={(e) =>
                                                            handleQuantityChange(
                                                                index,
                                                                e.target.value
                                                            )
                                                        }
                                                        disabled={!lot.checked}
                                                    />
                                                </td>
                                                <td>
                                                    {lot.expiry_date &&
                                                    moment(
                                                        lot.expiry_date
                                                    ).isValid()
                                                        ? moment(
                                                              lot.expiry_date
                                                          ).format('YYYY-MM-DD')
                                                        : 'N/A'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={onConfirm}>
                    Confirm
                </button>
                <button className="btn btn-secondary" onClick={onCancel}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    product_lot_inputs: state.sales_order.product_lot_inputs,
});

export default connect(mapStateToProps, {
    handleProductLotInput,
    handleLotConfirm,
})(PickLotNo);
